import React from "react";

import TrimetModeIcon from "../trimet-mode-icon-2021";

import ModeIconRenderer from "./mode-icon-renderer";

export default {
  title: "Icons/TrimetModeIcon2021",
  component: TrimetModeIcon
};

export const TrimetModeIcon2021Examples = () => (
  <ModeIconRenderer component={TrimetModeIcon} />
);
